module.exports = __webpack_public_path__ + "static/session_player-765edaab717e6fad82656d4847c652b2.png";